import IService from "../IService";

export enum ErrorSource {
	PANEL = "panel",
	VIEW = "view",
	APP = "app",
	API = "api"
}

export interface IError {
	message: any;
	info: any;
	errorCode?: string;
}

export abstract class ILoggerService implements IService {
	protected static DEFAULT_ID = "raven";
	private static REGISTRY: string = "logger";

	public getRegistry(): string {
		return ILoggerService.REGISTRY;
	}

	public getActive(): string {
		return ILoggerService.DEFAULT_ID;
	}

	public getConditions = () => undefined;

	public abstract getServiceId(): string;

	public abstract reportError(source: ErrorSource, error: IError, location: string, errorCode?: string): string;

}



// WEBPACK FOOTER //
// ./src/core/service/logger/ILoggerService.ts